export default __webpack_public_path__ + "static/media/warning--low-ground-clearance--g3.ce30c364.png";